export { FirmwareBundleLatestVersionService } from '../../services/firmware-bundle-latest-version.service';
